import { collection, getDocs, query, where , doc , getDoc  } from "firebase/firestore";
import { db } from "../utils/firebase";
import * as firebase from "firebase/app";
// Gets the list of admin from the database and returns it as an array of emails. Its looking for the user type number 4 which is admin
export async function getAdminEmailList() {
    //TODO: Improve this function to get the admin list from the database
    const adminCollection = query(
        collection(db, 'Users'),
        where('userTypeNumber', '==', 4)
    );
    const adminSnapshot = await getDocs(adminCollection);
    const adminList = adminSnapshot.docs.map(doc => doc.data().email);
    console.log(adminList);
    return adminList;
}
// Gets the list of board members from the database and returns it as an array of emails. Its looking for the user type number 3 which is board member
export async function getBoardMemberEmailList() {
    const boardMemberCollection = query(
        collection(db, 'Users'),
        where('userTypeNumber', '==', 3)
    );
    const boardMemberSnapshot = await getDocs(boardMemberCollection);
    const boardMemberList = boardMemberSnapshot.docs.map(doc => doc.data().email);
    // console.log(boardMemberList);
    return boardMemberList;
}
// Gets the list of verified members from the database and returns it as an array of emails. Its looking for the user type number 2 which is verified member
export async function getVerifiedMemberEmailList() {
    const verifiedMemberCollection = query(
        collection(db, 'Users'),
        where('userTypeNumber', '==', 2)
    );
    const verifiedMemberSnapshot = await getDocs(verifiedMemberCollection);
    const verifiedMemberList = verifiedMemberSnapshot.docs.map(doc => doc.data().email);
    // console.log(verifiedMemberList);
    return verifiedMemberList;
}

// Send email to a list of emails
//TODO Test 
export async function sendEmail(emailList, subject, body) {
    await addDoc(collection(db, "mail"), {
        to: adminEmailList,
        message: {
        subject: `Proposal ${title} has been created`,
        html: `
            New Proposal Created
        `,
        },
    });

}
// Gets the list of non verified members from the database and returns it as an array of emails. Its looking for the user type number 1 which is non verified member
export async function getNonVerifiedMemberEmailList() {
    const nonVerifiedMemberCollection = query(
        collection(db, 'Users'),
        where('userTypeNumber', '==', 1)
    );
    const nonVerifiedMemberSnapshot = await getDocs(nonVerifiedMemberCollection);
    const nonVerifiedMemberList = nonVerifiedMemberSnapshot.docs.map(doc => doc.data().email);
    // console.log(nonVerifiedMemberList);
    return nonVerifiedMemberList;
}
// Gets the list of all members from the database and returns it as an array of emails. Its looking for the user type number 1, 2, 3, 4 which is all members
export async function getAllMemberEmailList() {
    const allMemberCollection = query(
        collection(db, 'Users'),
        where('userTypeNumber', '>=', 1)
    );
    const allMemberSnapshot = await getDocs(allMemberCollection);
    const allMemberList = allMemberSnapshot.docs.map(doc => doc.data().email);
    // console.log(allMemberList);
    return allMemberList;
}
//! List members of a community
// Gets list of members from a community from the database and returns it as an array of emails. Its looking for the user type number 1, 2, 3, 4 which is all members
export async function getCommunityMemberEmailList(community) {
    //! Not Working 
    const communityMemberCollection = query(
        collection(db, 'Users'),
        where('community', '==', community)
    );
    const communityMemberSnapshot = await getDocs(communityMemberCollection);
    const communityMemberList = communityMemberSnapshot.docs.map(doc => doc.data().email);
    // console.log(communityMemberList);
    return communityMemberList;
}

//! List of all communities
export async function getCommunitiesList() {
      const communitiesCollection = collection(db, 'Communities');
      const communitiesSnapshot = await getDocs(communitiesCollection);
      const communitiesList = communitiesSnapshot.docs.map(doc => doc.data());
      return communitiesList;
}

//! List of all Proposals
//* Not Tested 
export async function getProposalsList() {
    //? Not Tested 
    const proposalsCollection = collection(db, 'Proposals');
    const proposalsSnapshot = await getDocs(proposalsCollection);
    const proposalsList = proposalsSnapshot.docs.map(doc => doc.data());
    return proposalsList;
}



//! Get current Users
// Used on /Communities 
export async function getCurrentUser() {
    const userId = localStorage.getItem("id");
    if (!userId) { return null; }
    const docRef = doc(db, "Users", userId);
    const docSnap = await getDoc(docRef);
    return docSnap;
}